var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0183 8.46809L20.514 12.8406C20.8194 13.1269 20.8298 13.5994 20.5371 13.8981C20.3923 14.0401 20.1952 14.1199 19.9896 14.1199C19.784 14.1199 19.5869 14.0401 19.4421 13.8981L16.242 10.8081V18.7806C16.242 19.1948 15.8967 19.5306 15.4708 19.5306C15.045 19.5306 14.6997 19.1948 14.6997 18.7806V10.8081L11.5227 13.8981C11.2168 14.1529 10.7607 14.1358 10.4759 13.8588C10.191 13.5817 10.1734 13.1382 10.4354 12.8406L14.931 8.46809C15.2318 8.1773 15.7176 8.1773 16.0183 8.46809Z",
    fill: "#83888E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6152 20.2806H19.3264C19.7523 20.2806 20.0975 20.6164 20.0975 21.0306C20.0975 21.4448 19.7523 21.7806 19.3264 21.7806H11.6152C11.1894 21.7806 10.8441 21.4448 10.8441 21.0306C10.8441 20.6164 11.1894 20.2806 11.6152 20.2806Z",
    fill: "#83888E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.bfdc8cad9e3e1a2173585fc009445a54.svg";
export { ForwardRef as ReactComponent };